/**
 * Constants for swissanalytica
 * This file contains various constants used throughout the swissanalytica application.
 */

/**
 * swissanalytica contact information
 * These constants define the contact email and website for swissanalytica.
 */
export const INFO_SA_EMAIL = 'info@swissanalytica.ch'

/**
 * swissanalytica website URL
 * This constant defines the official website URL for swissanalytica.
 */
export const SA_WEBSITE = 'https://swissanalytica.ch'
